import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Country } from "../../core/model/country";
import { Currency } from "../../core/model/currency";
import { CurrencyService } from "../../core/service/currency.service";
import { CountryService } from "../../core/service/country.service";

@Component({
  selector: "app-edit-country",
  templateUrl: "./edit-country.component.html",
  styleUrls: ["./edit-country.component.scss"],
})
export class EditCountryComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  countryId: number;
  country: Country;
  currencies: Currency[];

  constructor(
    private _router: Router,
    private _currencyService: CurrencyService,
    private _countryService: CountryService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(5)],
      ],
      shortLabel: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(20)],
      ],
      longLabel: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(50)],
      ],
      currency: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.countryId = params["countryId"];
      this.getCountry(this.countryId);
      this.getCurrencies();
    });
  }

  getCountry(countryId) {
    this.loading = true;
    this._countryService.getCountryById(countryId).subscribe(
      (data) => {
        this.country = {
          ...data,
          currency: data.currency ? { ...data.currency } : new Currency(),
        };
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  getCurrencies() {
    this._currencyService.getAllCurrencies().subscribe(
      (data) => {
        this.currencies = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;

    const selected = (this.currencies || []).find(
      (c) => c.id === this.country.currency.id
    );
    if (selected) {
      this.country.currency = { ...selected };
    }

    this._countryService
      .putCountry(this.country)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/country");
  }
}
